
<div>
  <div v-for="(section, index) in sections" :key="index" class="mb-16">
    <poppins-card class="w-full mx-auto py-24">
      <div class="flex justify-between items-center">
        <h2 class="text-h4">{{ section.title }}</h2>
        <!-- <poppins-button v-if="section.isEditable" value="Edit" variant="text" /> -->
      </div>
      <component :is="section.component" v-if="section.component" class="mt-16" v-bind="section.props" />
    </poppins-card>
  </div>
</div>
